module.exports = __webpack_public_path__ + "static/img/pdall.ab59908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/pdall.png
// module id = KZvP
// module chunks = 1